import React, { Component } from 'react';
import { Layout } from 'antd';
import { CustomEditors } from 'components';
import { withRouter } from 'react-router-dom';
import './index.css';
import { connect } from 'react-redux';
import * as services from 'services';
import * as actions from 'actions';

const { Content } = Layout;

const mapStateToProps = state => ({
	authenticated: state.auth.authenticated,
});

const mapDispatchToProps = dispatch => ({
	validate: user => dispatch(actions.validate(user)),
	onDocumentsTitleChange: title => dispatch(actions.onDocumentsTitleChange(title)),
});

class MainContainer extends Component {
	state = {
		isFocus: false,
	};

	fetchGets = async datas => {
		const post = await services.postApi(this, '/api/archive/sentence/gets', datas, null);
		if (post && post.status === 200) {
			const datas = post.data.datas;
			if (datas.TITLE != null && datas.TITLE.trim() !== '제목없음') {
				this.props.onDocumentsTitleChange(datas.TITLE);
			}
			this.setState({
				title: datas.TITLE != null && datas.TITLE.trim() !== '제목없음' ? datas.TITLE : '',
				text: datas.BoardContents != null ? datas.BoardContents[0].CONTENTS : '',
			});
		}
	};

	constructor(props) {
		super(props);

		const USER = JSON.parse(window.localStorage.getItem('user'));
		if (USER != null) {
			props.validate(USER);
		}
		const board = props.match.params.board;
		this.state = {
			broken1: props.broken1,
			broken2: props.broken2,
			wmenu: props.wmenu,
			board,
		};
	}

	componentWillReceiveProps(nextProps) {
		const { broken1, broken2, wmenu, authenticated } = nextProps;
		this.setState({ broken1, broken2, wmenu, authenticated, board: nextProps.match.params.board });
	}

	async componentDidUpdate(prevProps, prevState) {
		if (this.state.authenticated !== prevState.authenticated) {
			if (this.state.authenticated) {
				//console.log(this.state.board);
				if (this.state.board !== '0') {
					this.fetchGets({ boardId: this.state.board });
				}
			}
		}
	}

	render() {
		const { broken1, broken2, wmenu, title, text } = this.state;

		return (
			<Content className="caixa">
				<CustomEditors
					broken1={broken1}
					broken2={broken2}
					wmenu={wmenu}
					titleContents={title}
					textContents={text}
				/>
			</Content>
		);
	}
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withRouter(MainContainer));
